import type { ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthContext.js';
import { Layout } from './components/Layout.js';
import { Dashboard } from './pages/Dashboard.js';
import { Crecimiento } from './pages/Crecimiento.js';
import { Ingesta } from './pages/Ingesta.js';
import { Login } from './pages/Login.js';
import { Reportes } from './pages/Reportes.js';
import { Tasa } from './pages/Tasa.js';

function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-6 text-slate-400">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/crecimiento"
        element={
          <RequireAuth>
            <Crecimiento />
          </RequireAuth>
        }
      />
      <Route
        path="/ingesta"
        element={
          <RequireAuth>
            <Ingesta />
          </RequireAuth>
        }
      />
      <Route
        path="/reportes"
        element={
          <RequireAuth>
            <Reportes />
          </RequireAuth>
        }
      />
      <Route
        path="/tasa"
        element={
          <RequireAuth>
            <Tasa />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
